// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"661":"8ae152c375dd1ce0","9206":"d4ad051aa0fccce7"}[chunkId] + ".css";
};